import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useDocumentTitle = () => {
  const { pathname } = useLocation();

  const title =
    pathname === '/'
      ? 'Home'
      : pathname === '/my-resume'
      ? 'Taiwo_Babarinde_Resume'
      : 'JazzDev - ' +
        pathname.split('/').filter(Boolean).pop().charAt(0).toUpperCase() +
        pathname.split('/').filter(Boolean).pop().slice(1).replace(/-/g, ' ');

  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;
    return () => {
      document.title = prevTitle;
    };
  });
};

export default useDocumentTitle;
